import { render, staticRenderFns } from "./MoreModule.vue?vue&type=template&id=4cf376fe&scoped=true"
import script from "./MoreModule.vue?vue&type=script&lang=js"
export * from "./MoreModule.vue?vue&type=script&lang=js"
import style0 from "./MoreModule.vue?vue&type=style&index=0&id=4cf376fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf376fe",
  null
  
)

export default component.exports